@if (questions.length === 1) {
  <h2 class="standalone-question" [innerHTML]="questions[0].question"></h2>
}
@if (formGroup) {
  <table>
    <thead>
      <tr>
        @if (questions.length > 1) {
          <th class="blank-header"></th>
        }
        <!-- we assume all questions have this same answers -->
        @for (answer of questions[0].answers; track answer) {
          <th>
            <div class="relative-header">
              @if (withInnerHTML) {
                <div [innerHTML]="answer.text"></div>
              } @else {
                <div>
                  <p>{{ answer.text }}</p>
                </div>
              }
              @if (answer.tooltip) {
                <div
                  #tooltip="matTooltip"
                  (click)="tooltip.toggle(); $event.preventDefault()"
                  [matTooltip]="answer.tooltip"
                  class="info-icon"
                  inlineSVG="/icons/icon-info.svg"
                ></div>
              }
            </div>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      <ng-container [formGroup]="formGroup">
        @for (question of questions; track question) {
          <mat-radio-group class="d-table-row" [formControlName]="question.formControlName">
            @if (questions.length > 1) {
              <td class="question-text-container" [innerHTML]="question.question"></td>
            }
            @for (answer of question.answers; track answer) {
              <td class="answer">
                <mat-radio-button [value]="answer.val"></mat-radio-button>
              </td>
            }
          </mat-radio-group>
        }
      </ng-container>
    </tbody>
  </table>
}
